<div class="item">
  <ion-checkbox
    class="checkbox"
    [ngClass]="{ disabled: isDisabled }"
    [ngModel]="checked"
    [disabled]="isDisabled"
    (ngModelChange)="onModelChange($event)"
  >
  </ion-checkbox>
  <ion-label class="label"> {{ label }}</ion-label>
</div>
